import React, { Component } from "react";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class TvLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      digits: ["", "", "", ""],
      isSubmitting: false,
      error: null,
    };
    this.inputRefs = [
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
    ];
  }

  componentDidMount() {
    // Check localStorage for cached TV session
    const cachedAuth = localStorage.getItem("tvAuthDetail");
    if (cachedAuth) {
      try {
        const authDetail = JSON.parse(cachedAuth);
        if (authDetail && authDetail.sessionId) {
          if (this.props.onAuthenticated) {
            this.props.onAuthenticated(authDetail);
          }
          return;
        }
      } catch (e) {
        localStorage.removeItem("tvAuthDetail");
      }
    }
    if (this.inputRefs[0].current) {
      this.inputRefs[0].current.focus();
    }
  }

  handleDigitChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const digits = [...this.state.digits];
    digits[index] = value.slice(-1);
    this.setState({ digits, error: null });

    // Auto-focus next input
    if (value && index < 3 && this.inputRefs[index + 1].current) {
      this.inputRefs[index + 1].current.focus();
    }
  };

  handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !this.state.digits[index] && index > 0) {
      if (this.inputRefs[index - 1].current) {
        this.inputRefs[index - 1].current.focus();
      }
    }
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };

  handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 4);
    if (pasted.length === 4) {
      const digits = pasted.split("");
      this.setState({ digits, error: null });
      if (this.inputRefs[3].current) {
        this.inputRefs[3].current.focus();
      }
    }
  };

  handleSubmit = () => {
    const otp = this.state.digits.join("");
    if (otp.length !== 4) {
      this.setState({ error: "Please enter all 4 digits" });
      return;
    }

    this.setState({ isSubmitting: true, error: null });

    var formData = new FormData();
    formData.append("tvKey", otp);

    fetch(configData.api_url + "Login/tvAuth", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success("Authenticated successfully");
          // Cache auth in localStorage for TV restarts
          localStorage.setItem("tvAuthDetail", JSON.stringify(data.detail));
          if (this.props.onAuthenticated) {
            this.props.onAuthenticated(data.detail);
          }
        } else {
          this.setState({
            isSubmitting: false,
            error: data.message || "Invalid or expired OTP",
            digits: ["", "", "", ""],
          });
          if (this.inputRefs[0].current) {
            this.inputRefs[0].current.focus();
          }
        }
      })
      .catch((error) => {
        console.error("TV Auth error:", error);
        this.setState({
          isSubmitting: false,
          error: "Authentication failed. Please try again.",
        });
      });
  };

  render() {
    const { digits, isSubmitting, error } = this.state;

    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
        }}
      >
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <Container>
          <Row className="justify-content-center">
            <Col xs={11} sm={8} md={6} lg={4}>
              <Card className="shadow-lg border-0" style={{ borderRadius: "16px" }}>
                <Card.Body className="p-5 text-center">
                  <div className="mb-4">
                    <i
                      className="bi bi-tv"
                      style={{ fontSize: "3rem", color: "#0f3460" }}
                    ></i>
                  </div>
                  <h3 className="mb-2" style={{ color: "#1a1a2e", fontWeight: "700" }}>
                    TV Dashboard
                  </h3>
                  <p className="text-muted mb-4">Enter 4-digit OTP to continue</p>

                  <div
                    className="d-flex justify-content-center gap-3 mb-4"
                    onPaste={this.handlePaste}
                  >
                    {digits.map((digit, index) => (
                      <input
                        key={index}
                        ref={this.inputRefs[index]}
                        type="text"
                        inputMode="numeric"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => this.handleDigitChange(index, e.target.value)}
                        onKeyDown={(e) => this.handleKeyDown(index, e)}
                        disabled={isSubmitting}
                        style={{
                          width: "60px",
                          height: "70px",
                          fontSize: "2rem",
                          fontWeight: "700",
                          textAlign: "center",
                          border: error ? "2px solid #dc3545" : "2px solid #dee2e6",
                          borderRadius: "12px",
                          outline: "none",
                          transition: "border-color 0.2s",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#0f3460";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = error ? "#dc3545" : "#dee2e6";
                        }}
                      />
                    ))}
                  </div>

                  {error && (
                    <div className="text-danger mb-3" style={{ fontSize: "0.9rem" }}>
                      <i className="bi bi-exclamation-circle me-1"></i>
                      {error}
                    </div>
                  )}

                  <Button
                    variant="primary"
                    size="lg"
                    className="w-100"
                    onClick={this.handleSubmit}
                    disabled={isSubmitting || digits.join("").length !== 4}
                    style={{
                      borderRadius: "10px",
                      padding: "12px",
                      fontWeight: "600",
                      backgroundColor: "#0f3460",
                      borderColor: "#0f3460",
                    }}
                  >
                    {isSubmitting ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Verifying...
                      </>
                    ) : (
                      "Enter Dashboard"
                    )}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
